import React, { useState, useEffect } from 'react';
import { Paper, Text, Button, Stack, Group } from '@mantine/core';
import { IconPlayerPlay } from '@tabler/icons-react';

const BottomStickySection = ({
  batch,
  currentClass,
  nextClass,
  onGoToCurrentClass,
  isVisible = true,
  inClassView = false
}) => {
  const [timeLeft, setTimeLeft] = useState('');
  const [batchStarted, setBatchStarted] = useState(false);
  const [nextClassTime, setNextClassTime] = useState('');

  useEffect(() => {
    if (!batch?.batch_start_time) return;

    const updateCountdown = () => {
      const batchStartTime = new Date(batch.batch_start_time);
      const now = new Date();
      const diff = batchStartTime - now;

      if (diff <= 0) {
        setBatchStarted(true);
        setTimeLeft('');

        // Calculate next class time if no current class
        if (!currentClass && nextClass?.available_at) {
          const nextClassDate = new Date(nextClass.available_at);
          const nextDiff = nextClassDate - now;

          if (nextDiff > 0) {
            const days = Math.floor(nextDiff / (1000 * 60 * 60 * 24));
            const hours = Math.floor((nextDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((nextDiff % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((nextDiff % (1000 * 60)) / 1000);

            if (days > 0) {
              setNextClassTime(`${days}d ${hours}h ${minutes}m ${seconds}s`);
            } else if (hours > 0) {
              setNextClassTime(`${hours}h ${minutes}m ${seconds}s`);
            } else if (minutes > 0) {
              setNextClassTime(`${minutes}m ${seconds}s`);
            } else {
              setNextClassTime(`${seconds}s`);
            }
          }
        }
        return;
      }

      setBatchStarted(false);

      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);

      if (days > 0) {
        setTimeLeft(`${days}d ${hours}h ${minutes}m ${seconds}s`);
      } else if (hours > 0) {
        setTimeLeft(`${hours}h ${minutes}m ${seconds}s`);
      } else if (minutes > 0) {
        setTimeLeft(`${minutes}m ${seconds}s`);
      } else {
        setTimeLeft(`${seconds}s`);
      }
    };

    updateCountdown();
    const interval = setInterval(updateCountdown, 1000);

    return () => clearInterval(interval);
  }, [batch?.batch_start_time, currentClass, nextClass]);

  if (!isVisible || inClassView) return null;
  //console.log('inClassView - ', inClassView);
  return (
    <Paper
      shadow="xl"
      radius="xl"
      p="lg"
      style={{
        position: 'fixed',
        bottom: '20px',
        left: '20px',
        right: '20px',
        zIndex: inClassView ? -1 : 1000,
        background: 'linear-gradient(135deg, #228be6 0%, #7c3aed 100%)',
        color: 'white',
        maxWidth: '400px',
        margin: '0 auto',
        textAlign: 'center',
        display: (!isVisible || inClassView) ? 'none' : 'block'
      }}
    >
      {!batchStarted ? (
        <Stack gap="xs">
          <Text size="sm" opacity={0.9}>
            Course Starts In
          </Text>
          <Text
            size="xl"
            fw={700}
            style={{
              fontFamily: 'monospace',
              letterSpacing: '2px'
            }}
          >
            {timeLeft}
          </Text>
        </Stack>
      ) : currentClass ? (
        <Button
          variant="white"
          color="blue"
          size="lg"
          fullWidth
          leftSection={<IconPlayerPlay size={20} />}
          onClick={onGoToCurrentClass}
          styles={{
            root: {
              color: '#228be6',
              fontWeight: 600
            }
          }}
        >
          Go to Current Class
        </Button>
      ) : nextClass && nextClassTime ? (
        <Stack gap="xs">
          <Text size="sm" opacity={0.9}>
            Next Class Available In
          </Text>
          <Text
            size="lg"
            fw={700}
            style={{
              fontFamily: 'monospace',
              letterSpacing: '1px'
            }}
          >
            {nextClassTime}
          </Text>
          <Text size="xs" opacity={0.8}>
            {nextClass.class.title}
          </Text>
        </Stack>
      ) : (
        <Stack gap="xs">
          <Text size="sm" opacity={0.9}>
            All Classes Completed!
          </Text>
          <Text size="lg" fw={700}>
            🎉 Congratulations! 🎉
          </Text>
        </Stack>
      )}
    </Paper>
  );
};

export default BottomStickySection;